import { useI18n } from '@affine/i18n';
import { OutlineViewer } from '@blocksuite/affine/fragments/outline';
import type { EditorHost } from '@blocksuite/affine/std';
import { useCallback, useEffect, useMemo, useRef } from 'react';

import * as styles from './outline-viewer.css';

export const EditorOutlineViewer = ({
  editor,
  show,
  openOutlinePanel,
}: {
  editor: EditorHost | null;
  show: boolean;
  openOutlinePanel?: () => void;
}) => {
  const t = useI18n();
  const outlineViewerRef = useRef<OutlineViewer | null>(null);
  const labels = useMemo(
    () => ({
      title: t['com.streamlain.rightSidebar.outline'](),
      previewSettings: t['com.streamlain.outlinePanel.previewSettings'](),
      visibilityAndSort: t['com.streamlain.outlinePanel.visibilityAndSort'](),
      openSidebar: t['com.streamlain.outlinePanel.openSidebar'](),
    }),
    [t]
  );

  const onRefChange = useCallback(
    (container: HTMLDivElement | null) => {
      if (container && editor) {
        if (outlineViewerRef.current) {
          outlineViewerRef.current.remove();
        }
        outlineViewerRef.current = new OutlineViewer();
        outlineViewerRef.current.editor = editor;
        outlineViewerRef.current.toggleOutlinePanel = openOutlinePanel ?? null;
        outlineViewerRef.current.labels = labels;
        container.append(outlineViewerRef.current);
      }
    },
    [editor, labels, openOutlinePanel]
  );

  useEffect(() => {
    if (outlineViewerRef.current) {
      outlineViewerRef.current.labels = labels;
    }
  }, [labels]);

  if (!editor || !show) return null;

  return <div className={styles.root} ref={onRefChange} />;
};
